import { render, staticRenderFns } from "./loginOpens.vue?vue&type=template&id=56072dbe&scoped=true&"
import script from "./loginOpens.vue?vue&type=script&lang=js&"
export * from "./loginOpens.vue?vue&type=script&lang=js&"
import style0 from "./loginOpens.vue?vue&type=style&index=0&lang=less&"
import style1 from "./loginOpens.vue?vue&type=style&index=1&id=56072dbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56072dbe",
  null
  
)

export default component.exports